import $ from "jquery";


export default class MailChimpForm {
  constructor(element) {
    this.passedElement = element;
    this.init();
  }

  init = () => {
    if (!this.initialised) {
      this.initialised = true;
      this.hasAnimated = false;
      this.form = $(this.passedElement);
      this.animated = this.form.data("animated");
      this.action = this.passedElement.getAttribute('action');
      this.formNotes = this.form.find('.form-notes');
      this.emailInput = this.form.find("input[type='email']");
      this.formContent = $("#mc_embed_signup_scroll, #mergeRow-gdpr");
      this.titles = $(".js-mailchimp-title");
      this.signInButton = $(".rf-hero-form__login");
      this.emailRegion = $(".rf-hero-form__email");
      this.formInner = $(".rf-hero-form__inner");
      this.heroFormGDPR = $(".rf-hero-form__gdpr");
      this.heroFormSubmit = $(".rf-hero-form__submit");
      this._addEventListeners();
    }
  }

  _addEventListeners() {
    this.passedElement.addEventListener('submit', this.handleSubmit);
  }

  _removeEventListeners() {

  }

  validateAndSubmitForm = () => {
    this.formNotes.empty();

    if (!this.isValidEmail()) {
      this.formNotes.append('<p class="form-notes__error">Please enter a valid email address</p>')
    }

    if (!this.hasTickedCheckbox()) {
      this.formNotes.append('<p class="form-notes__error">Please agree to the terms and conditions</p>')
    }

    if (this.isValidEmail() && this.hasTickedCheckbox()) {
      this.formNotes.empty();
      this.submitForm();
      this.formNotes.append("<p>Subscribing...</p>")
    }
  }

  handleSubmit = (e) => {
    e.preventDefault();
    if (this.animated) {
      if (this.hasAnimated) {
        this.validateAndSubmitForm();
      } else {
        this.animateForm();
      }
    } else {
      this.validateAndSubmitForm();
    }
  }

  animateForm = () => {
    if (!this.hasAnimated) {

      if (this.scrollToBannerIfLessThanWidth(500)) {
        return;
      }

      $(".js-fade-out").animate({
        height: 0,
        opacity: 0,
        padding: 0,
        margin: 0,
      }).toggleClass('hidden');

      this.heroFormSubmit.animate({
        paddingLeft: 16,
        paddingRight: 16,
      });

      this.heroFormGDPR.animate({
        opacity: 1,
        height: 72,
      }).addClass('__open');

      this.signInButton.fadeOut();

      setTimeout(() => {
        this.emailRegion.fadeIn(200, () => {
          this.emailRegion.animate({
            flexBasis: 220,
            opacity: 1,
            marginRight: 16,
          }, () => {
          })
        });

      }, 250);

      this.hasAnimated = true;
    }
  }

  scrollToBannerIfLessThanWidth = (width) => {
    let screenWidth = $(document).width();

    if (screenWidth <= width) {
      $([document.documentElement, document.body]).animate({
          scrollTop: $(".rf-call-to-action").offset().top,
      }, 1500);
      return true;
    }
    return false;
  }

  submitForm = () => {

    let formNotes = this.formNotes;
    let formContent = this.formContent;
    let titles = this.titles;


    $.ajax({
      type: "GET",
      url: this.action,
      data: this.form.serialize(),
      cache: false,
      dataType: "jsonp",
      jsonp: "c", // trigger MailChimp to return a JSONP response
      contentType: "application/json; charset=utf-8",

      error: function(error) {
        // According to jquery docs, this is never called for cross-domain JSONP requests
      },

      success: function(data) {
        if (data.result != "success") {
          var message = data.msg || "Sorry. Unable to subscribe. Please try again later.";
          // this.formNotes.addClass("is-invalid");
          if (data.msg && data.msg.indexOf("already subscribed") >= 0) {
            formNotes.empty();
            formContent.remove();
            formNotes.append("<p class='form-notes__success'>You're already subscribed. Thank you.</p>");
            titles.text("Thank you!");
          }
          formNotes.empty();
          formNotes.append(`<p class='form-notes__error'>${message}</p>`);
        } else {
          formNotes.empty();
          formContent.remove();
          formNotes.append("<p class='form-notes__success'>Please confirm the subscription in your inbox.</p>");
          titles.text("Thank you!");
        }
      }
    });

  }

  isValidEmail = () => {
    let emailValue = this.emailInput.val();
    return (!emailValue || !emailValue.length || emailValue.indexOf("@") == -1) ? false : true;
  }

  hasTickedCheckbox = () => {
    return this.passedElement.querySelector("input[type='checkbox']").checked;
  }


  dismantle = () => {
    this._removeEventListeners();
    this.initialised = false;
  }
}
